export class vec2 extends Array<number> {
	get x() { return this[0] }
	get y() { return this[1] }
	set x(v) { this[0] = v }
	set y(v) { this[1] = v }
	constructor(x: number = 0, y: number = 0) {
		super(2)
		this.x = x
		this.y = y
	}
	add(v: vec2) { return new vec2(this.x + v.x, this.y + v.y) }
	sub(v: vec2) { return new vec2(this.x - v.x, this.y - v.y) }
}

export class vec3 extends Array<number> {
	get x() { return this[0] }
	get y() { return this[1] }
	get z() { return this[2] }
	set x(v) { this[0] = v }
	set y(v) { this[1] = v }
	set z(v) { this[2] = v }
	constructor(x: number = 0, y: number = 0, z: number = 0) {
		super(3)
		this.x = x
		this.y = y
		this.z = z
	}
	add(v: vec3) { return new vec3(this.x + v.x, this.y + v.y, this.z + v.z) }
	// sub(v: vec3) { return new vec3(this.x - v.x, this.y - v.y, this.z - v.z) }
	div(n: number) { return new vec3(this.x / n, this.y / n, this.z / n) }
	norm() { return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z) }
	normalized() { return this.div(this.norm()) }
}

// class vec4 {
// 	content: [number, number, number, number] = [0, 0, 0, 0]
// 	get x() { return this.content[0] }
// 	get y() { return this.content[1] }
// 	get z() { return this.content[2] }
// 	get w() { return this.content[3] }
// 	set x(v) { this.content[0] = v }
// 	set y(v) { this.content[1] = v }
// 	set z(v) { this.content[2] = v }
// 	set w(v) { this.content[3] = v }
// 	constructor(x: number = 0, y: number = 0, z: number = 0, w: number = 0) { this.content = [x, y, z, w] }
// 	add(v: vec4) { return new vec4(this.x + v.x, this.y + v.y, this.z + v.z, this.w + v.w) }
// 	sub(v: vec4) { return new vec4(this.x - v.x, this.y - v.y, this.z - v.z, this.w - v.w) }
// }

// class mat2 {
// 	content: [number, number, number, number] = [0, 0, 0, 0]
// 	constructor(x: [number, number, number, number]) { this.content = x }
// 	transpose() { return new mat2([this.content[0], this.content[3], this.content[2], this.content[1]]) }
// }

export class mat3 extends Array<number> {
	// static id() { return new mat3() }
	// static zero() { return new mat3([0, 0, 0, 0, 0, 0, 0, 0, 0]) }
	constructor(x: [number, number, number, number, number, number, number, number, number] = [1, 0, 0, 0, 1, 0, 0, 0, 1]) {
		super(9)
		if (x) x.map((v, i) => this[i] = v)
	}
	transpose() {
		return new mat3(
			[this[0], this[3], this[6],
			this[1], this[4], this[7],
			this[2], this[5], this[8]])
	}
	show() {
		console.log(Math.floor(this[0] * 100) / 100, Math.floor(this[1] * 100) / 100, Math.floor(this[2] * 100) / 100)
		console.log(Math.floor(this[3] * 100) / 100, Math.floor(this[4] * 100) / 100, Math.floor(this[5] * 100) / 100)
		console.log(Math.floor(this[6] * 100) / 100, Math.floor(this[7] * 100) / 100, Math.floor(this[8] * 100) / 100)
	}
	mult(b: mat3) {
		let a = this
		let m: [number, number, number, number, number, number, number, number, number] = [0, 0, 0, 0, 0, 0, 0, 0, 0]
		for (let i = 0; i < 3; i++) {
			for (let j = 0; j < 3; j++) {
				m[3 * i + j] = a[0 + 3 * i] * b[0 + j] + a[1 + 3 * i] * b[3 + j] + a[2 + 3 * i] * b[6 + j]
			}
		}
		return new mat3(m)
	}
	static rot(v: vec3) {
		let θ = v.norm()
		if (θ == 0) return new mat3()
		let c = Math.cos(θ)
		let s = Math.sin(θ)
		v = v.normalized()
		let x = v.x
		let y = v.y
		let z = v.z
		return new mat3([
			c + x * x * (1 - c), x * y * (1 - c) - z * s, x * z * (1 - c) + y * s,
			y * x * (1 - c) + z * s, c + y * y * (1 - c), y * z * (1 - c) - x * s,
			z * x * (1 - c) - y * s, z * y * (1 - c) + x * s, c + z * z * (1 - c)
		])
	}
}

// let a = new mat3([0,1,0,0,0,0,0,0,0])
// let b = new mat3([1,2,3,4,5,6,7,8,9])
// a.show()
// b.show()
// console.log(' ')
// a.mult(b).show()
// console.log(' ')
// b.mult(a).show()
